export var StripeAccountConnectionStatus;
(function (StripeAccountConnectionStatus) {
    StripeAccountConnectionStatus["CONNECTED"] = "connected";
    StripeAccountConnectionStatus["DISCONNECTED"] = "disconnected";
})(StripeAccountConnectionStatus || (StripeAccountConnectionStatus = {}));
// @ash - this is kind of the better way to parse DB types than the model overrides I think! Prevents use of `as`
export function parseStripeConnectStatus(value) {
    switch (value) {
        case 'connected':
            return StripeAccountConnectionStatus.CONNECTED;
        case 'disconnected':
            return StripeAccountConnectionStatus.DISCONNECTED;
        default:
            throw new Error(`Unknown StripeConnectStatus: ${value}`);
    }
}
//# sourceMappingURL=stripeAccount.js.map